// Reports.js

import React from "react";
import { Typography } from "@mui/material";

function Reports() {
  return <Typography variant="h4">Reports - Work in Progress</Typography>;
}

export default Reports;
